<template>
  <div class="px-8 py-6" style="height:100dvh; width:100%;overflow-y: auto;">
    <h3>발주 현황</h3>
    <FilterModal
      :filterList="filterList"
      :listItems="listItems"
      :statusList="statusList"
      :statusName="'발주상태'"
      @sendFilterData="receiveFilterData"
    />
    <div class="pt-3 align-center d-flex">
      <div class="pr-5">
        <v-select
          v-resize="updateWindowHeight"
          solo
          flat
          class="width100-height30 border-5c5c5c"
          height="26px"
          dense
          :items="searchItems"
          item-text="searchText"
          item-value="searchValue"
          v-model="searchCategory"
          :menu-props="{ offsetY: true }"
        />
      </div>
      <input
        class="cursor-pointer border-5c5c5c back-white width300-height30"
        v-model="searchWord"
        @keyup.enter="startAndReset(1)"
      />
      <v-btn
        width="78"
        height="30"
        color="#3F557D"
        class="color-white ml-3"
        @click="startAndReset(1)"
      >
        <span class="search-text"> 조회</span>
      </v-btn>
      <v-spacer />

      <!-- 직접입력 - 차후계정만 활성화 -->
      <CreateOrderModal
        @orderReset="startAndReset"
        v-if="isAdmin && isDevMode"
      />

      <!-- 일괄발주 - 차후계정만 활성화 -->
      <div>
        <v-btn
          width="120"
          height="30"
          class="border-btn align-center justify-center d-flex pa-0 ml-2"
          @click="$bus.$emit('OrderFormOn')"
          v-if="isAdmin && isDevMode"
        >
          <UploadIcon :fill="viewerRole ? 'grey' : '#0038FF'" class="mr-1" />
          <span class="border-text">일괄발주</span>
        </v-btn>
      </div>

      <div>
        <v-btn
          class="border-btn align-center justify-center d-flex pa-0 mx-4"
          width="120"
          height="30"
          @click="$bus.$emit('drawingUpload')"
          v-if="roleType != '입고담당자'"
          :disabled="viewerRole"
        >
          <UploadIcon :fill="viewerRole ? 'grey' : '#0038FF'" class="mr-1" />
          <span class="border-text ">도면업로드</span>
        </v-btn>
      </div>

      <div>
        <v-btn
          class="border-btn  align-center justify-center d-flex"
          width="120"
          height="30"
          @click="openSmsList('order')"
          v-if="roleType != '입고담당자'"
          :disabled="viewerRole"
        >
          <MsgIcon :fill="viewerRole ? 'grey' : '#0038FF'" class="mr-1" />
          <span class="border-text ">발주알림</span>
        </v-btn>
      </div>
      <div class="pl-4">
        <v-btn
          class="border-btn  align-center justify-center d-flex"
          width="120"
          height="30"
          @click="excelDown"
          :disabled="viewerRole"
        >
          <DownloadIcon :fill="viewerRole ? 'grey' : '#0038FF'" class="mr-1" />
          <span class="border-text ">내려받기</span>
        </v-btn>
      </div>
    </div>
    <div class="pt-5 pb-2">
      <h2 class="color-red danger-text">
        ※ 일부 출고되었거나, 출고완료 된 발주건은 발주량 수정 불가합니다.
      </h2>
    </div>
    <div class="pb-5">
      <v-simple-table
        ref="tableRef"
        class="width-100"
        :height="windowInnerHeight - 48 - 300"
        fixed-header
        dense
      >
        <thead>
          <tr>
            <th
              class="text-center back-8ca9dd color-white border-right-white cursor-pointer first-child1"
              rowspan="2"
              @click="orderByAlone('orderName')"
            >
              <div style="width: 80px; ">
                차수<v-icon color="white"
                  >{{
                    orderNameState == "asc" ? "mdi-arrow-up" : "mdi-arrow-down"
                  }}
                </v-icon>
              </div>
            </th>
            <th
              rowspan="2"
              class="back-8ca9dd color-white text-center border-right-white cursor-pointer first-child2"
              @click="orderByAlone('partName')"
              style="z-index:15 !important"
            >
              부위<v-icon color="white">{{
                partState == "asc" ? "mdi-arrow-up" : "mdi-arrow-down"
              }}</v-icon>
            </th>
            <th
              rowspan="2"
              class="floor-td back-8ca9dd color-white text-center border-right-white"
            >
              동
            </th>
            <th
              rowspan="2"
              class="floor-td back-8ca9dd color-white text-center border-right-white "
            >
              층
            </th>
            <th
              rowspan="2"
              class="floor-td back-8ca9dd color-white text-center border-right-white align-center justify-center "
            >
              부재
            </th>
            <th
              rowspan="1"
              class="back-8ca9dd color-white text-center border-right-white"
              :colspan="materialLengh"
            >
              규격(단위:TON)
            </th>
            <th rowspan="2" class="back-8ca9dd color-white text-center ">
              합계수량
            </th>
            <th
              rowspan="2"
              class="back-8ca9dd color-white text-center border-left-white border-right-white w-80"
              @click="orderByAlone('output')"
            >
              출고여부<v-icon color="white">{{
                outputState == "asc" ? "mdi-arrow-up" : "mdi-arrow-down"
              }}</v-icon>
            </th>
            <th
              rowspan="2"
              class="back-8ca9dd color-white text-center  cursor-pointer"
              @click="orderByAlone('date')"
            >
              발주일자
              <v-icon color="white">{{
                dateState == "asc" ? "mdi-arrow-up" : "mdi-arrow-down"
              }}</v-icon>
            </th>
            <th
              rowspan="2"
              class="w-100 back-8ca9dd color-white text-center border-right-white border-left-white"
              v-if="roleTypeStatus"
            >
              샵업체
            </th>
            <th
              rowspan="2"
              class="w-100 back-8ca9dd color-white text-center border-right-white"
              v-if="roleTypeStatus"
            >
              가공업체
            </th>
            <th
              rowspan="2"
              class="back-8ca9dd color-white text-center border-right-white"
            >
              도면
            </th>
            <th
              class="back-8ca9dd color-white text-center border-right-white"
              rowspan="2"
            >
              메모
            </th>
          </tr>
          <tr>
            <th
              class="back-8ca9dd color-white text-center border-top-white border-right-white"
              v-for="list in materialList"
              :key="list.rebar_id"
            >
              {{ list.rebar_name }}
            </th>
          </tr>
          <tr class="text-center" v-if="orderList.length > 0">
            <th
              colspan="2"
              class="border-left-aaaaaa border-right-aaaaaa text-center back-cadbf9 first-child1"
            >
              총합
            </th>
            <th class="border-right-aaaaaa back-ecf3f9" colspan="3"></th>
            <th
              v-for="(orderList, index) in ordersumList"
              :key="index"
              class="border-right-aaaaaa text-right back-ecf3f9 px-1"
            >
              {{ orderList ? mathRound(orderList).toFixed(3) : "0" }}
            </th>
            <th class="border-right-aaaaaa text-right back-ecf3f9 px-1">
              {{ sum(ordersumList).toFixed(3) }}
            </th>
            <th colspan="6" class="border-right-aaaaaa back-ecf3f9"></th>
          </tr>
        </thead>
        <tbody v-if="orderList.length > 0">
          <tr v-for="index in tbodyLength" :key="index">
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa border-left-aaaaaa text-center back-f5f5f5 first-child1"
            >
              <div class="" style="width:78px;">
                {{ orderList[index - 1].orderName }}
              </div>
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-center  color-0038FF justify-start back-f5f5f5 first-child2"
            >
              <v-btn
                @click="
                  move(
                    orderList[index - 1].orderStatus,
                    orderList[index - 1].orderId
                  )
                "
                color="#0038FF"
                text
                width="228"
                class="text-start font-12 "
              >
                {{ orderList[index - 1].partName }}
              </v-btn>
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa  text-center font-12 px-1"
            >
              {{ orderList[index - 1].dong }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa  text-center font-12 px-1"
            >
              {{ orderList[index - 1].floor }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-center font-12 px-1"
            >
              {{ orderList[index - 1].type }}
            </td>
            <td
              class="cnt-td border-right-aaaaaa  border-bottom-aaaaaa text-right px-1"
              v-for="(inList, i) in orderList[index - 1].rebarList"
              :key="i"
            >
              {{ inList ? mathRound(inList).toFixed(3) : "0" }}
            </td>
            <td
              class="cnt-td border-right-aaaaaa border-bottom-aaaaaa text-right px-1"
            >
              {{ sum(orderList[index - 1].rebarList).toFixed(3) }}
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa text-center">
              <div
                :style="colorStatus(orderList[index - 1].orderStatus)"
                class="font-12"
              >
                {{ orderList[index - 1].orderStatus }}
              </div>
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-center font-12"
            >
              {{ orderList[index - 1].registDate | moment("YY.MM.DD") }}
            </td>
            <td
              v-if="roleTypeStatus"
              class="w-fit px-1 border-right-aaaaaa border-bottom-aaaaaa text-center font-12"
            >
              {{ orderList[index - 1].orderCompany }}
            </td>
            <td
              v-if="roleTypeStatus"
              class="w-fit px-1 border-right-aaaaaa border-bottom-aaaaaa text-center font-12"
            >
              {{ orderList[index - 1].invoiceCompany }}
            </td>

            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-center color-0038FF "
              v-if="orderList[index - 1].cadCheck == 'Y'"
            >
              <v-btn
                color="#0038FF"
                text
                @click="
                  downPlan(
                    orderList[index - 1].orderId,
                    orderList[index - 1].partName
                  )
                "
                width="100"
              >
                다운로드
              </v-btn>
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-center color-0038FF "
              v-if="orderList[index - 1].cadCheck == 'N'"
            >
              <v-btn
                @click="uploadPlan(orderList[index - 1].orderId)"
                color="#0038FF"
                text
                width="100"
                :disabled="viewerRole"
              >
                업로드
              </v-btn>
            </td>

            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-center  color-0038FF"
            >
              <v-btn
                @click="memoClick(orderList[index - 1].orderId, 'order')"
                :color="orderList[index - 1].memo ? '#0038FF' : '#ff0000'"
                text
                width="80"
                :disabled="orderList[index - 1].memo ? false : viewerRole"
              >
                {{ orderList[index - 1].memo ? "보기" : "추가" }}
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
    <div class="justify-center pb-4 mb-4">
      <v-pagination
        v-model="page"
        color="#8EB4FA"
        :length="pageLength"
        v-if="orderList.length > 0"
        :total-visible="10"
      ></v-pagination>
    </div>

    <Detail />
    <Drawing />
    <Approal />
  </div>
</template>

<script>
import DatePickerMixin from "@/mixin/DatePicker";
import Search from "@/mixin/Search";
import Commonality from "@/mixin/Commonality";

import OrderApi from "@/api/OrderService";
import FileApi from "@/api/FileService";

import FilterModal from "@/components/Filter";

import Drawing from "./modal/DrawingUpload.vue";
import CreateOrderModal from "@/views/order/modal/CreateOrderModal.vue";

import Detail from "./OrderDetail.vue";
import Approal from "./OrderApproal.vue";
import fileDownload from "@/assets/js/file-download.js";
// import FirstPage from "@/views/modal/form/FirstPage.vue";
import UploadIcon from "@/assets/svgs/UploadIcon.vue";
import MsgIcon from "@/assets/svgs/MsgIcon.vue";
import DownloadIcon from "@/assets/svgs/DownloadIcon.vue";

export default {
  mixins: [DatePickerMixin, Search, Commonality],
  components: {
    CreateOrderModal,
    Detail,
    Drawing,
    Approal,
    FilterModal,
    // FirstPage,
    UploadIcon,
    MsgIcon,
    DownloadIcon,
  },

  created() {
    if (!this.isStoreFilter) {
      this.startAndReset();
    }
    this.$bus.$on("orderNavigationDuplicated", async () => {
      await this.startAndReset(1);
    });
  },
  beforeDestroy() {
    this.$bus.$off("orderNavigationDuplicated");
  },
  data: () => ({
    orderList: [],
    materialLengh: 1,
    orderTotalList: [],
    ordersumList: [],
    tbodyLength: 0,
    orderNameState: "desc",
    partState: null,
    outputState: null,
    dateState: null,
    filterList: {},
    listItems: [{ searchText: "발주일자", searchValue: 1 }],
    methodFilterData: {},
    statusList: [
      {
        name: "미 출고",
        status: true,
      },
      {
        name: "승인요청",
        status: true,
      },
      {
        name: "일부출고",
        status: true,
      },
      {
        name: "출고완료",
        status: true,
      },
      {
        name: "수정요청",
        status: true,
      },
    ],
    windowInnerHeight: 0,
    bundleOrder: false,
  }),
  computed: {
    roleTypeStatus() {
      let roleType = this.$store.getters.getUserList.roleType;
      return roleType == "시스템관리자" || roleType == "현장관리자";
    },
    isDevMode() {
      return this.$store.getters?.getAppsetting?.projectName.includes("dev");
    },
    userInfo() {
      return this.$store.getters.getUserList;
    },
    isAdmin() {
      return (
        this.userInfo?.accountName === "chahoo" &&
        this.userInfo?.companyName === "차후" &&
        this.userInfo?.roleType === "시스템관리자"
      );
    },
    /** 저장된 필터 있는지 여부 */
    isStoreFilter() {
      return this.$store.getters?.getOrderFilter;
    },
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
  },

  watch: {
    page(val) {
      this.startAndReset(val);
      this.scrollTop();
    },
  },
  methods: {
    /** table Scroll top 이동함수 */
    scrollTop() {
      const container = this.$refs.tableRef?.$el?.querySelector(
        ".v-data-table__wrapper"
      );
      if (container) {
        container.scrollTop = 0;
      }
    },
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
    orderByAlone(payload) {
      if (payload == "orderName") {
        this.dateState = null;
        this.partState = null;
        this.outputState = null;
        this.orderNameState =
          this.orderNameState && this.orderNameState != "asc" ? "asc" : "desc";
      } else if (payload == "partName") {
        this.orderNameState = null;
        this.dateState = null;
        this.outputState = null;
        this.partState =
          this.partState && this.partState != "asc" ? "asc" : "desc";
      } else if (payload == "date") {
        this.orderNameState = null;
        this.partState = null;
        this.outputState = null;
        this.dateState =
          this.dateState && this.dateState != "asc" ? "asc" : "desc";
      } else if (payload == "output") {
        this.orderNameState = null;
        this.partState = null;
        this.dateState = null;
        this.outputState =
          this.outputState && this.outputState != "asc" ? "asc" : "desc";
      }
      this.startAndReset();
    },

    async startAndReset(payload) {
      this.$bus.$emit("loadingStart");

      let data = {
        constructionId: this.constructionId,
        type: this.searchCategory,
        keyword: this.searchWord,
        startDate: this.startDate,
        endDate: this.finishDate,
        currentPage: payload ? payload : this.page,
        order: [
          this.orderNameState,
          this.partState,
          this.outputState,
          this.dateState,
        ],
        pageCount: 20,
      };
      data = Object.assign(data, this.methodFilterData);
      this.materialLengh = this.materialList.length;
      let resultData = await OrderApi.orderTotalList(data);
      this.orderTotalList = resultData.data.orderList;
      this.orderList = this.orderTotalList;
      this.ordersumList = resultData.data.orderTotalList[0];
      this.pageLength = resultData.data.pageInfo.endPage;
      this.page = resultData.data.pageInfo.currentPage;
      this.tbodyLength = resultData.data.orderList.length;
      let res = await OrderApi.orderFilterListSearch(data);
      this.filterList = res.data;
      this.$bus.$emit("loadingEnd");
    },
    async excelDown() {
      this.$bus.$emit("loadingStart");
      let data = {
        constructionId: this.constructionId,
        type: this.searchCategory,
        keyword: this.searchWord,
        startDate: this.startDate,
        endDate: this.finishDate,
        order: [
          this.orderNameState,
          this.partState,
          this.outputState,
          this.dateState,
        ],
      };
      data = Object.assign(data, this.methodFilterData);
      let res = await FileApi.orderDown(data);
      if (res.data.size > 0) {
        fileDownload(
          res.data,
          `${this.constructionName.constructionName} 발주현황.xlsx`
        );
      } else {
        this.$bus.$emit("dialog", "서버 문제로 잠시 후 실행해주세요.");
      }
      this.$bus.$emit("loadingEnd");
    },
    async downPlan(value, value2) {
      this.$bus.$emit("loadingStart");
      try {
        const res = await FileApi.cadDownload({ orderId: value });

        fileDownload(
          res.data,
          `${this.constructionName.constructionName}_${value2}.${
            res.headers["content-disposition"].split(".")[1]
          }`
        );
        this.$bus.$emit("loadingEnd");
      } catch (e) {
        this.$bus.$emit("dialog", "도면 다운로드에 실패했습니다.", false);
        this.$bus.$emit("loadingEnd");
        console.error(e);
      }
      this.$bus.$emit("loadingEnd");
    },
    uploadPlan(value) {
      this.$bus.$emit("drawingUpload", value);
    },
    openSmsList(data) {
      this.$bus.$emit("smsOpen", data);
    },
    move(status, value) {
      if (status == "승인요청" || status == "수정요청") {
        this.$bus.$emit("approalOn", value);
      } else {
        this.$bus.$emit("orderDetail", value);
      }
    },
    colorStatus(status) {
      if (status == "미출고") return "color: #888888";
      else if (status == "승인요청" || status == "일부출고")
        return "color: #FF0000";
      else if (status == "출고완료") return "color: #37AC00";
    },

    receiveFilterData(data) {
      this.methodFilterData = data;
      this.searchWord = "";
      this.startAndReset(1);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-btn[disabled],
.v-btn:disabled {
  border: 1px solid transparent !important;
}
.v-data-table--fixed-header.v-data-table--dense
  > .v-data-table__wrapper
  > table
  > thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
.first-child1 {
  position: sticky;
  left: 0;
  z-index: 8 !important;
  min-width: 80px !important;
}
.first-child2 {
  position: sticky;
  left: 80px;
  min-width: 230px !important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 100%;
}
.font-12 {
  font-size: 12px;
}
.v-data-table--fixed-header.v-data-table--dense
  > .v-data-table__wrapper
  > table
  > thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
tr > .w-100 {
  min-width: 100px !important;
  width: fit-content;
}
.w-80 {
  width: 80px !important;
}
.m-w-80 {
  min-width: 80px !important;
}
.m-w-100 {
  min-width: 100px;
}

.pt-10 {
  padding-top: 10px;
}

.width179-height41 {
  width: 179px;
  height: 41px !important;
}

.width100-height30 {
  width: 100px !important;
  height: 30px !important;
}

.v-text-field {
  height: 32px !important;
}

.cnt-td {
  min-width: fit-content;
  max-width: 120px;
}
.floor-td {
  min-width: 80px;
  max-width: 110px;
}
.w-fit {
  min-width: fit-content !important;
  max-width: 120px;
}
@media (max-width: 1000px) {
  .width-100 {
    width: 1605px !important;
  }
}
</style>
